import { useEffect, useState } from "react";
import { Row, Spin, Col } from "antd";
import { Pie } from "@ant-design/plots";
import { VehicleOverview } from "src/modules/vehicle/types";

const PieChart = ({
  vehicleOverview,
  loading,
}: {
  vehicleOverview: VehicleOverview;
  loading: boolean;
}) => {
  const [data, setData] = useState<any>([]);

  useEffect(() => {
    if (!loading) {
      setData(vehicleOverview.type_wise_vehicle_total);
    }
  }, [loading]);

  const config = {
    data,
    angleField: "value",
    colorField: "type",
    label: {
      text: "value",
      style: {
        fontWeight: "bold",
      },
    },
    legend: {
      color: {
        title: false,
        position: "right",
        rowPadding: 5,
      },
    },
  };

  return loading ? (
    <Row>
      <Col span={24} style={{ textAlign: "center", paddingTop: "10%" }}>
        <Spin size="large" />
      </Col>
    </Row>
  ) : (
    <Pie {...config} />
  );
};

export default PieChart;
